import React from "react";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { Box, Link as MuiLink, Typography } from "@mui/material";
import { MdKeyboardArrowDown } from "react-icons/md";
import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import Layout from "../../layouts/layout";
import PageHeading from "../../layouts/pageHeading";
import { cssProperties } from "../../utils/commonCssProperties";
import { cardSx } from "./common";

const crumbSx = {
  color: cssProperties?.fontcolor?.primary,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  display: "flex",
  alignItems: "center",
  gap: "12px",
};

/**
 * Layout of the Email pages: header with breadcrumbs, sidebar, heading and the white card.
 * crumbs: [{ label, to? }] after Dashboard; the last one is the current page.
 */
export default function EmailPage({ title, crumbs, children }) {
  const project = Cookies.get("mhet_mst_project");
  const breadcrumbs = [
    <MuiLink key="home" underline="hover" component={NavLink} to={`/${project}/home`} sx={{ ...crumbSx, fontWeight: 400 }}>
      Dashboard
    </MuiLink>,
    ...crumbs.map((c, i) => {
      const last = i === crumbs.length - 1;
      return c.to && !last ? (
        <MuiLink key={c.label} underline="hover" component={NavLink} to={c.to} sx={{ ...crumbSx, fontWeight: 400 }}>
          {c.label}
        </MuiLink>
      ) : (
        <Typography key={c.label} sx={{ ...crumbSx, fontWeight: last ? "bold" : 400 }}>
          {c.label} {last && <MdKeyboardArrowDown size={16} />}
        </Typography>
      );
    }),
  ];
  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <Sidebar />
      <Layout>
        <PageHeading title={title} />
        <Box sx={cardSx}>{children}</Box>
      </Layout>
    </>
  );
}
